
import { Component, Prop, Vue } from "vue-property-decorator";
import AdmIconButton from "@afe/admirals-dev/src/components/AdmIconButton";
import AdmButton from "@afe/admirals-dev/src/components/AdmButton";

@Component({
  components: {
    AdmButton,
    AdmIconButton
  }
})
export default class extends Vue {
  @Prop({ default: "" }) readonly submit?: string;
  @Prop({ default: "" }) readonly btnId?: string;
}
